module.exports = __webpack_public_path__ + "img/estate_assist_icon.ed632977.svg";